import { HTMLCustomElement } from '@emartech/ui-framework-utils';
import hyperHTML from 'hyperhtml';
import CustomEvent from 'custom-event';
import popupHandler from '../../utils/popup-handler';
import JSLogger from '../../../js/utils/jslogger';
import template from './template';
const log = new JSLogger('dataselect');

class EDataselect extends HTMLCustomElement {
  init() {
    this._dom = {
      wrapper: document.createElement('e-dataselect-wrapper'),
      listWrapper: document.createElement('div'),
      actionList: document.createElement('e-actionlist')
    };
    this._dom.listWrapper.style.zIndex = 602;

    this._eventHandlers = {
      open: this._openEvent.bind(this),
      change: this._changeEvent.bind(this),
      search: this._searchEvent.bind(this)
    };

    this._state = {
      options: [],
      selected: undefined,
      placeholder: 'Select an option...',
      height: false
    };

    this._dom.actionList.className = 'e-dataselect__actionlist';
    this._dom.actionList.autofocus = true;
    this._dom.actionList.alwaysShowSearch = true;
    this._dom.actionList.addEventListener('change', this._eventHandlers.change);
    this._dom.actionList.addEventListener('search', this._eventHandlers.search);

    this._dom.listWrapper.appendChild(this._dom.actionList);
    this._renderer = hyperHTML.bind(this._dom.wrapper);
  }

  connectedCallback() {
    super._cleanupContainer('e-datagrid-wrapper');
    this.appendChild(this._dom.wrapper);
    this._render();
  }

  static get observedAttributes() {
    return ['data', 'value', 'placeholder', 'loading', 'height', 'max-height'];
  }

  set data(value) {
    try {
      this._state.options = typeof value === 'string' ? JSON.parse(value) : value;
      this._render();
      this._renderList();
    } catch (error) {
      log.warn('Error while parsing data');
    }
  }

  set value(value) {
    try {
      this._state.selected = typeof value === 'string' ? JSON.parse(value) : value;
      this._render();
      this._renderList();
    } catch (error) {
      log.warn('Error while parsing data');
    }
  }

  set placeholder(value) {
    this._state.placeholder = value;
    this._render();
  }

  set loading(value) {
    this._dom.actionList.loading = super._convertAttributeToBoolean(value);
  }

  set height(value) {
    this._dom.actionList.height = value;
  }

  set maxHeight(value) {
    this._dom.actionList.maxHeight = value;
  }

  _openEvent() {
    popupHandler.openPopper({
      reference: this._dom.wrapper,
      opener: this,
      popperElement: this._dom.listWrapper,
      popperConfig: {
        placement: 'bottom-start',
        removeOnDestroy: true,
        modifiers: {
          calcPopupSize: {
            enabled: true,
            function: data => this._calcPopupSize(data),
            order: 800
          }
        }
      },
      openCallback: this._renderList.bind(this)
    });

    this.dispatchEvent(new CustomEvent('open'));
  }

  _changeEvent(event) {
    const selectedOption = this._state.options.filter(option => option.value === event.detail.value)[0];

    this._state.selected = selectedOption;

    this._render();
    this.dispatchEvent(new CustomEvent('change', {
      detail: {
        value: this._state.selected.value,
        label: this._state.selected.label
      }
    }));

    popupHandler.close(this);
  }

  _searchEvent(event) {
    this._renderList();
    this.dispatchEvent(new CustomEvent('search', { detail: { value: event.detail.value } }));
  }

  _calcPopupSize(data) {
    this._dom.listWrapper.style.width = data.offsets.reference.width + 'px';
    return data;
  }

  _render() {
    template(this._renderer, this._state, this._eventHandlers);
  }

  _renderList() {
    if (!this._dom.listWrapper.parentNode) { return; }

    this._dom.actionList.items = this._state.options.map(option => {
      return {
        type: 'option',
        content: option.label,
        value: option.value,
        selected: this._state.selected && option.value === this._state.selected.value
      };
    });

    setTimeout(() => {
      popupHandler.updatePopper(this); // fix glitch when popup does not fit to window
    });
  }
}

export default EDataselect;
